import { createSlice } from '@reduxjs/toolkit';
import { ProductsData, ProductItem, ProductPack, UpsellItem } from './productsTypes';
import { v4 as uuidv4 } from 'uuid';

const productPack: ProductPack = window.productData;

const initialState: ProductsData = {
  Products:
    productPack?.products &&
    productPack.products.map((product: ProductItem) => {
      return {
        ...product,
        id: uuidv4(),
        type: 'offer',
      };
    }),
  Upsells: {
    bundle_pack_upsell:
      productPack?.bundle_pack_upsells?.bundle_pack_upsells_repeater &&
      productPack?.bundle_pack_upsells?.bundle_pack_upsells_repeater?.map((upsell: UpsellItem) => {
        return {
          ...upsell,
          id: uuidv4(),
          type: 'upsell',
        };
      }),
    upsell_view_modal: {
      benefits: {
        benefits_list: true,
        tr_title: 'Title',
      },
      faq: true,
      gallery: true,
      swiper_gallery: true,
      testimonials: true,
      tr_add_to_cart_button_text: 'Add to Cart',
    },
  },
  Warranty: {
    display_name: productPack?.warranty_product_name,
    enabled: productPack?.add_warranty_for_product,
    preselect: productPack?.preselect_warranty,
    sku: productPack?.warranty_product_sku,
    konnektive_id: productPack?.warranty_product_konnektive_id,
    multiply_warranty: productPack?.multiply_price_by_amount,
    price: 0,
  },
  campaignData: {
    campaign_id: productPack?.konnektive_campaign_id,
    locale: productPack?.locale,
    next_page_on_success: productPack?.next_page_on_success,
    currency_code: productPack?.currency_code,
    enable_3ds_waterfall: productPack?.enable_3ds_waterfall,
    three_ds_waterfall_campaign_id: productPack?.three_ds_waterfall_campaign_id,
  },
  Shipping: {
    enable_free_shipping_gift: productPack?.shopping_cart?.enable_free_shipping_gift,
    free_shipping_minimum: productPack?.shopping_cart?.free_shipping_minimum,
    shipping_price: 0,
  },
};

const productsdataSlice = createSlice({
  name: 'productsdata',
  initialState,
  reducers: {},
});

export default productsdataSlice.reducer;
